import { ExternalAccountFormValues } from '@/types/externalAccounts';

export const initialExternalAccountForm: ExternalAccountFormValues = {
  companyId: '',
  customerId: '',
  bankName: '',
  accountType: '',
  accountNumber: '',
  confirmAccountNumber: '',
  routingNumber: '',
  bankAddress: {
    line1: '',
    line2: '',
    city: '',
    state: '',
    postalCode: '',
  },
  ownerName: '',
  ownerAddress: {
    line1: '',
    line2: '',
    city: '',
    state: '',
    postalCode: '',
  },
  bankAccountApplicationId: '',
  proofsOfOwnership: [{ value: '' }],
  documentDisplayNames: [''],
  paymentType: '',
};
